import {
  Footer,
  FooterAffix,
  FooterAppDownload,
  FooterLinkSection,
} from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import { ReservedWords, getContentUrl } from "@kunduz/utility-common";
import YT from "@icons/youtubeIconV2.svg";
import Insta from "@icons/instagramIconV2.svg";
import FB from "@icons/facebookIcon.svg";
import LIN from "@icons/linkedinIcon.svg";
import TW from "@icons/twitterIcon.svg";

export const WebsiteTrFooter = (): ReactElement => {
  const { t } = useTranslation("kunduzcom_common");

  const courses = [
    {
      label: "Matematik",
      slug: "matematik",
    },
    {
      label: "Geometri",
      slug: "geometri",
    },
    {
      label: "Fizik",
      slug: "fizik",
    },
    {
      label: "Kimya",
      slug: "kimya",
    },
    {
      label: "Biyoloji",
      slug: "biyoloji",
    },
    {
      label: "Türk Dili ve Edebiyatı",
      slug: "turk-dili-ve-edebiyati",
    },
    {
      label: "Türkçe",
      slug: "turkce",
    },
    {
      label: "Coğrafya",
      slug: "cografya",
    },
    {
      label: "Fen Bilimleri",
      slug: "fen-bilimleri",
    },
    {
      label: "İnkılap Tarihi",
      slug: "inkilap-tarihi",
    },
    {
      label: "Sosyal Bilgiler",
      slug: "sosyal-bilgiler",
    },
  ];
  const grades = [
    {
      label: "12. Sınıf",
      slug: "12-sinif",
    },
    {
      label: "11. Sınıf",
      slug: "11-sinif",
    },
    {
      label: "10. Sınıf",
      slug: "10-sinif",
    },
    {
      label: "9. Sınıf",
      slug: "9-sinif",
    },
    {
      label: "8. Sınıf",
      slug: "8-sinif",
    },
    {
      label: "7. Sınıf",
      slug: "7-sinif",
    },
    {
      label: "6. Sınıf",
      slug: "6-sinif",
    },
    {
      label: "5. Sınıf",
      slug: "5-sinif",
    },
  ];
  const exams = [
    {
      label: "YKS",
      slug: "yks",
    },
    {
      label: "AYT",
      slug: "ayt",
    },
    {
      label: "TYT",
      slug: "tyt",
    },
    {
      label: "LGS",
      slug: "lgs",
    },
  ];
  const popCourses = [
    {
      label: "TYT Matematik",
      slug: "tyt-matematik",
    },
    {
      label: "TYT Geometri",
      slug: "tyt-geometri",
    },
    {
      label: "TYT Türkçe",
      slug: "tyt-turkce",
    },
    {
      label: "AYT Matematik",
      slug: "ayt-matematik",
    },
    {
      label: "AYT Geometri",
      slug: "ayt-geometri",
    },
    {
      label: "AYT Fizik",
      slug: "ayt-fizik",
    },
    {
      label: "AYT Kimya",
      slug: "ayt-kimya",
    },
    {
      label: "AYT Biyoloji",
      slug: "ayt-biyoloji",
    },
    {
      label: "AYT Türk Dili ve Edebiyatı",
      slug: "ayt-turk-dili-ve-edebiyati",
    },
    {
      label: "AYT Coğrafya",
      slug: "ayt-cografya",
    },
    {
      label: "11. Sınıf Matematik",
      slug: "11-sinif-matematik",
    },
    {
      label: "LGS Matematik",
      slug: "lgs-matematik",
    },
    {
      label: "LGS Türkçe",
      slug: "lgs-turkce",
    },
    {
      label: "LGS Fen Bilimleri",
      slug: "lgs-fen-bilimleri",
    },
    {
      label: "LGS İnkılap Tarihi",
      slug: "lgs-inkilap-tarihi",
    },
    {
      label: "7. Sınıf Matematik",
      slug: "7-sinif-matematik",
    },
    {
      label: "7. Sınıf Türkçe",
      slug: "7-sinif-turkce",
    },
    {
      label: "7. Sınıf Fen Bilimleri",
      slug: "7-sinif-fen-bilimleri",
    },
    {
      label: "7. Sınıf Sosyal Bilgiler",
      slug: "7-sinif-sosyal-bilgiler",
    },
  ];
  const popModules = [
    {
      label: "Limit ve Süreklilik",
      slug: "limit-ve-sureklilik",
    },
    {
      label: "Türev",
      slug: "turev",
    },
    {
      label: "İntegral",
      slug: "integral",
    },
    {
      label: "Üslü Sayılar",
      slug: "uslu-sayilar",
    },
    {
      label: "Polinomlar",
      slug: "polinomlar",
    },
    {
      label: "Fonksiyonlar",
      slug: "fonksiyonlar",
    },
    {
      label: "Problemler",
      slug: "problemler",
    },
    {
      label: "Trigonometri",
      slug: "trigonometri",
    },
    {
      label: "Analitik Geometri",
      slug: "analitik-geometri",
    },
    {
      label: "Elektrostatik",
      slug: "elektrostatik",
    },
    {
      label: "Dalgalar",
      slug: "dalgalar",
    },
    {
      label: "Optik",
      slug: "optik",
    },
    {
      label: "DNA ve Genetik Kod",
      slug: "dna-ve-genetik-kod",
    },
    {
      label: "Organik Bileşikler",
      slug: "organik-bilesikler",
    },
    {
      label: "Maddenin Halleri",
      slug: "maddenin-halleri",
    },
    {
      label: "Sindirim Sistemi",
      slug: "sindirim-sistemi",
    },
    {
      label: "Solunum Sistemi",
      slug: "solunum-sistemi",
    },
    {
      label: "Anlatım Bozuklukları",
      slug: "anlatim-bozukluklari",
    },
    {
      label: "Halk Şiiri",
      slug: "halk-siiri",
    },
    {
      label: "Divan Şiiri",
      slug: "divan-siiri",
    },
  ];

  return (
    <Footer
      firstColumnLinks={
        <>
          <FooterLinkSection
            title="Kullanıcılar"
            links={[
              {
                label: "Öğrenci",
                slug: "/tr/",
              },
              {
                label: "Eğitmen",
                slug: "/tr/egitmen/",
              },
              {
                label: "Okullar",
                slug: "/tr/okul/",
              },
              {
                label: "Kunduz US",
                slug: "/",
                locale: "en-US",
              },
              {
                label: "Paketler",
                slug: "/tr/paketler/sinifini-sec/",
              },
              {
                label: "Sorular",
                slug: "/tr/sorular/",
              },
            ]}
          />
          <FooterLinkSection
            title="Araçlar"
            links={[
              {
                label: "YKS Puan Hesaplama",
                slug: "/tr/yks-puan-hesaplama/",
              },
              {
                label: "LGS Puan Hesaplama",
                slug: "/tr/lgs-puan-hesaplama/",
              },
            ]}
          />
        </>
      }
      secondColumnLinks={
        <>
          <FooterLinkSection
            title="Dersler"
            links={courses.map((c, i) => ({
              label: c.label,
              slug: getContentUrl({
                lang: "tr",
                contentType: ReservedWords.TR_CONTENT_COURSE,
                segments: [c.slug],
              }),
            }))}
          />
          <FooterLinkSection
            title="Sınıflar"
            links={grades.map((c, i) => ({
              label: c.label,
              slug: getContentUrl({
                lang: "tr",
                contentType: ReservedWords.TR_CONTENT_GRADE,
                segments: [c.slug],
              }),
            }))}
          />
          <FooterLinkSection
            title="Sınavlar"
            links={exams.map((c, i) => ({
              label: c.label,
              slug: getContentUrl({
                lang: "tr",
                contentType: ReservedWords.TR_CONTENT_EXAM,
                segments: [c.slug],
              }),
            }))}
          />
        </>
      }
      thirdColumnLinks={
        <>
          <FooterLinkSection
            title="Popüler Kurslar"
            links={popCourses.map((c, i) => ({
              label: c.label,
              slug: getContentUrl({
                lang: "tr",
                contentType: ReservedWords.TR_CONTENT_PATH_DETAIL,
                segments: [c.slug],
              }),
            }))}
          />
          <FooterLinkSection
            title="Popüler Üniteler"
            links={popModules.map((c, i) => ({
              label: c.label,
              slug: getContentUrl({
                lang: "tr",
                contentType: ReservedWords.TR_CONTENT_MODULE,
                segments: [c.slug],
              }),
            }))}
          />
        </>
      }
      forthColumnLinks={
        <>
          <FooterLinkSection
            title="Kurumsal"
            links={[
              {
                label: "Biz Kimiz",
                slug: "/tr/hakkimizda/",
              },
              {
                label: "Blog",
                slug: "/tr/blog/",
              },
              {
                label: "SSS",
                slug: "/tr/sss/",
              },
              {
                label: "İletişim",
                slug: "/tr/iletisim/",
              },
              {
                label: "KVKK",
                slug: "/tr/kvkk/",
              },
              // {
              //   label: "Gizlilik Sözleşmesi",
              //   slug: "/tr/gizlilik-ilkeleri/",
              // },
              {
                label: "Kullanım Koşulları",
                slug: "/tr/kullanim-kosullari/",
              },
            ]}
          />
          <FooterAppDownload
            title="Uygulamalar"
            items={[
              {
                imageUrl: "/images/applestore.webp",
                link: "https://apps.apple.com/tr/app/kunduz-yks-lgs-soru-%C3%A7%C3%B6z%C3%BCm%C3%BC/id1083827128?l=tr",
              },
              {
                imageUrl: "/images/googleplay.webp",
                link: "https://play.google.com/store/apps/details?id=com.ngier.roket&hl=tr",
              },
            ]}
          />
        </>
      }
      affix={
        <FooterAffix
          socialLinks={[
            { icon: TW, slug: "https://x.com/kunduzasor" },
            { icon: Insta, slug: "https://instagram.com/kunduzasor" },
            { icon: FB, slug: "https://www.facebook.com/kunduzasor/" },
            {
              icon: YT,
              slug: "https://www.youtube.com/channel/UCMW7HaTlQn1xEdiV7cx-7VA",
            },
            { icon: LIN, slug: "https://www.linkedin.com/company/kunduz/" },
          ]}
        />
      }
    />
  );
};
